import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import AdminConnector, { ConnectorProps as AdminProps } from '../../connectors/Admin'
import { AdminOptionsType } from '../../types'

const AdminOptions: FC<AdminOptionsType> = ({ accountUserID, socialLinks }: AdminOptionsType) => {
  const AdminPanel = dynamic(
    import(
      /* webpackChunkName: "adminPanel" */
      './AdminPanel'
    ),
    noSSR
  )
  const SocialLinks = dynamic(
    import(
      /* webpackChunkName: "SocialLinks" */
      './SocialLinks'
    ),
    noSSR
  )
  return (
    <>
      <SocialLinks />
      <AdminPanel accountUserID={accountUserID} socialLinks={socialLinks} />
    </>
  )
}

const Admin: FC<AdminProps> = ({ accountUserID, isAdmin, socialLinks }: AdminProps) => {
  if (!isAdmin) {
    return null
  }

  return <AdminOptions accountUserID={accountUserID} socialLinks={socialLinks} />
}

export default AdminConnector(Admin)
